import React from "react";
import ToggleFullScreenButton from "./ToggleFullScreenButton";
import ToggleMuteButton from "./ToggleMuteButton";
import TogglePublisherAudioButton from "./TogglePublisherAudioButton";
import TogglePublisherUIButton from "./TogglePublisherUIButton";
import TogglePublisherVideoButton from "./TogglePublisherVideoButton";
import ToggleScreenShareButton from "./ToggleScreenShareButton";

const PublisherControls = () => (
  <>
    <div className="controller-container">
      <div className="controller-column">
        <TogglePublisherUIButton />
      </div>
      <div className="controller-column">
        <TogglePublisherAudioButton />
        <TogglePublisherVideoButton />
        <ToggleScreenShareButton />
      </div>
      <div className="controller-column">
        <ToggleMuteButton />
        <ToggleFullScreenButton />
      </div>
    </div>
    <style jsx>
      {`
        .controller-container {
          background: #fbfbfc;
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          z-index: 4;
          padding: 0 20px;
        }
        .controller-column {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .controller-column p {
          padding: 0 5px 0 18px;
          color: #3a3a3b;
        }
        .controller-column div {
          padding: 0 5px 0 5px;
        }
        .screenshare-options-dialog-container {
          position: absolute;
          width: 77%;
          height: 190px;
          bottom: 150%;
          left: 10%;
          background: #fbfbfc;
          border-radius: 10px;
          z-index: 5;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          box-shadow: 2px 2px 10px rgba(166, 171, 189, 0.5);
          border-top: double 3px transparent;
          background: linear-gradient(white, white),
            radial-gradient(circle at top left, #8f2398, #3e93d3);
          background-origin: border-box;
          background-clip: content-box, border-box;
        }
      `}
    </style>
  </>
);
export default PublisherControls;
